export default __webpack_public_path__ + "static/media/Months_00.bc724b42.png";